import { render } from "./ReportsListView.vue?vue&type=template&id=9e9864a4&scoped=true"
import script from "./ReportsListView.vue?vue&type=script&lang=js"
export * from "./ReportsListView.vue?vue&type=script&lang=js"

import "./ReportsListView.vue?vue&type=style&index=0&id=9e9864a4&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e9864a4"]])

export default __exports__